import * as ents from '@attain-apps/entities'
import { TypeAsserter } from '@attain-apps/type-guards'
import type cytoscape from 'cytoscape'

import type { Feature } from '../../feature'
import type * as models from '../../models'

/**
 * Allows the user to move nodes around and to drag them on top of each other to
 * reassign them
 */
export function setupDragAndDrop(
  cy: cytoscape.Core,
  { feature, chartId }: setupDragAndDrop.AdditionalParams,
): void {
  cy.nodes().grabify()

  cy.on('dragfree', 'node', event => {
    const droppedNode = event.target as cytoscape.NodeSingular

    const droppedNodeBounds = droppedNode.boundingBox()

    cy.nodes()
      .not(droppedNode)
      .forEach(otherNode => {
        const otherNodeBounds = otherNode.boundingBox()

        // Check for intersection
        if (
          droppedNodeBounds.x1 < otherNodeBounds.x2 &&
          droppedNodeBounds.x2 > otherNodeBounds.x1 &&
          droppedNodeBounds.y1 < otherNodeBounds.y2 &&
          droppedNodeBounds.y2 > otherNodeBounds.y1
        ) {
          feature.actions.assign.from('Cytoscape.Node.Dragfree').dispatch({
            chartId,
            edge: {
              childId: TypeAsserter.validate(
                droppedNode.id(),
                ents.core.display.tree.Node.Id.assertIsId,
              ),
              parentId: TypeAsserter.validate(
                otherNode.id(),
                ents.core.display.tree.Node.Id.assertIsId,
              ),
            },
          })
        }
      })
  })
}
export namespace setupDragAndDrop {
  export interface AdditionalParams extends models.Chart.Identifier {
    readonly feature: Feature
  }
}
